/**
 * Dosya türleri listesi
 */
export const typeList = [
  { value: '1', label: 'DOSYA' },
  { value: '2', label: 'SUNUM' },
  { value: '3', label: 'TEKLİF' },
  { value: '4', label: 'PROSEDÜR' },
  { value: '5', label: 'TALİMAT' },
  { value: '6', label: 'GÖRSEL' },
  { value: '7', label: 'VİDEO' },
]

/**
 * Dosya türü ismi döndürür
 *
 * @param {String|Number} val - Tür ID'si
 * @returns {String} Tür adı
 */
export const getFileTypeName = (val) => {
  if (!val) return '-'
  return typeList.find(r => Number(r.value) === val)?.label || '-'
}

/**
 * Tüm dosya türlerini döndürür
 *
 * @returns {Array} Türler listesi
 */
export const getTypesAll = () => {
  return typeList
}